export const MuiMenu = () => ({
  styleOverrides: {
    paper: {
      padding: 0,
      borderRadius: '8px',
    },
    list: {
      padding: '8px 0',
    },
  },
});
